export const ALLERGY_SUGGESTION_OPTIONS = [
  "None",
  "Tree nuts",
  "Eggs",
  "Gluten",
  "Wheat",
  "Soy",
  "Shellfish",
  "Fish",
  "Sesame",
];

export const DIETARY_SUGGESTION_OPTIONS = [
  "Vegetarian",
  "Vegan",
  "Halal",
  "Kosher",
  "Gluten-free",
  "Dairy-free",
  "No pork",
  "Pureed / soft foods",
];

export const CARE_GOAL_CATEGORY_OPTIONS = [
  { value: "", label: "Choose category" },
  { value: "communication", label: "Communication" },
  { value: "social-skills", label: "Social Skills" },
  { value: "emotional-regulation", label: "Emotional Regulation" },
  { value: "behavior", label: "Behavior" },
  { value: "transitions", label: "Transitions" },
  { value: "sensory-processing", label: "Sensory Processing" },
  { value: "self-care", label: "Self-Care" },
  { value: "academic-skills", label: "Academic Skills" },
  { value: "motor-skills", label: "Motor Skills" },
  { value: "safety-awareness", label: "Safety Awareness" },
  { value: "independence", label: "Independence" },
  { value: "other", label: "Other" },
];

export const CARE_GOAL_SOURCE_OPTIONS = [
  { value: "", label: "Choose source" },
  { value: "iep", label: "IEP" },
  { value: "aba-program", label: "ABA Program" },
  { value: "speech-therapy", label: "Speech Therapy" },
  { value: "occupational-therapy", label: "Occupational Therapy" },
  { value: "home-goal", label: "Home Goal" },
  { value: "medical-team", label: "Medical Team" },
  { value: "other", label: "Other" },
];

export const CARE_GOAL_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "completed", label: "Completed" },
  { value: "paused", label: "Paused" },
  { value: "archived", label: "Archived" },
];
